import cn from 'classnames';
import { useSearchParams } from 'react-router-dom';
import { Favorite } from '@features/common/SmallCardStatus/Favorite/index.tsx';
import { ModerationStatusViewer } from '@features/common/SmallCardStatus/ModerationStatus/index.tsx';
import { NoPaid } from '@features/common/SmallCardStatus/NoPaid/index.tsx';
import { Favorite as FavoriteIcon } from '@shared/assets/index.ts';
import type { ModerationStatus } from '@src/library/models/events.ts';
import * as st from './styles.module.scss';

type PT = {
  isAuthor: boolean;
  isPublished?: boolean;
  isPaid?: boolean;
  moderationStatus: ModerationStatus;
  // cost?: string;
  isFavorite: boolean;
  className?: string;
  isNeedToShowOnlyIcon?: boolean;
};

export const SmallCardStatus = ({
  isPublished,
  isPaid,
  isAuthor,
  moderationStatus,
  // cost,
  isFavorite,
  className,
  isNeedToShowOnlyIcon,
}: PT) => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab');

  // const needToShowIsPaid = useMemo(
  //   () => Boolean(cost && isPaid && !isAuthor && cost_base > 0),
  //   [isPaid, isAuthor, cost_base]
  // );

  return (
    <div className={cn(st.status, className)}>
      {isAuthor && activeTab !== 'all' && (
        <ModerationStatusViewer
          isNeedToShowOnlyIcon={isNeedToShowOnlyIcon}
          isPublished={isPublished || false}
          moderationStatus={moderationStatus}
        />
      )}
      <Favorite isFavorite={isFavorite} />

      {/*не знаю почему назвали иконку "favorite Icon", по сути там просто звездочка*/}
      {isPublished && isAuthor && <FavoriteIcon className={st.publishedStar} />}

      <NoPaid isPaid={isPaid} />
    </div>
  );
};
